import React from 'react';
import styles from '../irlObservations2026.module.css';
import { ModalShell } from '../chrome';

export default function IRL_AI_Review_Review_Response_2({ value, onChange, onNext, onBack, onClose }) {
    return (
        <ModalShell>
            <div className={styles.modalHead}>
                <h2 className={styles.modalTitle}>AI Review</h2>
                <button type="button" className={styles.modalClose} onClick={onClose} aria-label="Close">
                    ×
                </button>
            </div>
            <div className={styles.modalBody}>
                <p className={styles.modalIntro}>Use Lens to review requests, responses and available project evidence. Lens suggestions require human confirmation before they become project records.</p>
                <div className={styles.sectionLabelSm}>Additional instructions</div>
                <p className={styles.modalIntro}>Optional — Lens will follow within your existing access permissions and evidence scope.</p>
                <textarea className={styles.textarea} value={value} onChange={event => onChange(event.target.value)} placeholder="Example: Focus on resilience, security and any responses that conflict with architecture documentation." />
            </div>
            <div className={styles.modalFoot}>
                <button type="button" className={styles.primaryBtn} onClick={onNext}>
                    Next
                </button>
                <button type="button" className={styles.mutedBtn} onClick={onBack}>
                    Back
                </button>
            </div>
        </ModalShell>
    );
}
